import { render, staticRenderFns } from "./taskManagement.vue?vue&type=template&id=167fbf74&scoped=true"
import script from "./taskManagement.vue?vue&type=script&lang=js"
export * from "./taskManagement.vue?vue&type=script&lang=js"
import style0 from "./taskManagement.vue?vue&type=style&index=0&id=167fbf74&prod&lang=scss"
import style1 from "./taskManagement.vue?vue&type=style&index=1&id=167fbf74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167fbf74",
  null
  
)

export default component.exports